import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'fi-shared-lead-checkbox',
  templateUrl: './shared-lead-checkbox.component.html',
  styleUrls: ['./shared-lead-checkbox.component.scss'],
  standalone: false,
})
export class SharedLeadCheckboxComponent {
  @Input() checked = false;
  @Input() disabled = false;
  @Output() checkedChange = new EventEmitter<boolean>();

  onValueChange( value: boolean ): void {
    this.checked = value;
    this.checkedChange.emit(this.checked);
  }
}
